import { convertQueryStringToObject, queryString } from './';

export default function addQueryToUrl(url = '', query = {}) {
    let finalQuery = query;

    const pathAndQuery = url.split('?');
    if (pathAndQuery.length > 1) {
        const urlQuery = convertQueryStringToObject(pathAndQuery[1]);
        finalQuery = { ...urlQuery, ...finalQuery };
    }
    return `${pathAndQuery[0]}${queryString(finalQuery)}`;
};



// WEBPACK FOOTER //
// ./app/lib/format/addQueryToUrl.js